import { useApiClient } from '@m43/core';
import { CautionsTabResource } from '@mark43/cad-api';
import { useQuery } from '@tanstack/react-query';
import { TAB_QUERY_CACHE_TIME } from '../tabs/constants';

export function useEventAssociatedPersonsQuery(props: { eventId?: number }) {
    const apiClient = useApiClient();
    return useQuery(
        ['GetAssociatedPersons', props.eventId] as const,
        ({ queryKey }) => {
            return apiClient
                .request<CautionsTabResource.GetAssociatedPersons>({
                    method: 'GET',
                    url: `cautions_tab/${queryKey[1]}/associated_persons`,
                })
                .then((data) => {
                    return data.data.data;
                });
        },
        {
            cacheTime: TAB_QUERY_CACHE_TIME,
            refetchInterval: 5000,
            keepPreviousData: true,
            enabled: !!props.eventId,
        }
    );
}
